import React, { useContext, useEffect, useState } from "react";
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { getMapPin } from "../../commons/MapPin";
import { useHistory } from "react-router-dom";
import { SchoolContext } from "../../context/SchoolContext";

const SchoolMap = ({ selected }) => {
  const { schoolList, setSchool } = useContext(SchoolContext);
  const [activeSchool, setActiveSchool] = useState(null);

  const history = useHistory();

  useEffect(() => {
    setActiveSchool(schoolList[selected]);
    //eslint-disable-next-line
  }, [selected]);

  if (!(schoolList.length > 0)) {
    return null;
  }

  return (<MapContainer
    // default centre location pin for map
    center={[schoolList[0].latitude, schoolList[0].longitude]}
    zoom="11" scrollWheelZoom={false}
    className="map__view"
  >
    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    {schoolList.map((school, i) => (
      <Marker
        key={i}
        position={[
          school.latitude,
          school.longitude
        ]}
        eventHandlers={{
          click: () => setActiveSchool(school)
        }}
        icon={getMapPin({ text: i + 1, textColor: 'black', pinColor: '#eee' })}
      />
    ))}

    {activeSchool && (
      <Popup
        position={[
          activeSchool.latitude,
          activeSchool.longitude
        ]}
        onClose={() => {
          setActiveSchool(null);
        }}
      >
        {
          <span className="text-primary text-link font-weight-bold" onClick={() => {
            setSchool(activeSchool.id);
            history.push(`/home/dashboard/${activeSchool.id}`);
          }} >
            {activeSchool.user_name}
            {/* {activeSchool.title} */}
          </span>
        }
      </Popup>
    )}
  </MapContainer>);
};

export default SchoolMap;